import { createIcon } from '@chakra-ui/react';

export const MbePasswordOn = createIcon({
  displayName: 'MbePasswordOn',
  viewBox: '0 0 38 38',
  path: (
    <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor" fillRule="evenodd">
        <path d="M19.297 26.034c-8.034 0-12.98-5.548-14.162-7.035 1.178-1.489 6.11-7.033 14.162-7.033 8.034 0 12.98 5.547 14.162 7.034-1.18 1.489-6.11 7.034-14.162 7.034zm15.485-7.397c-.222-.325-5.569-7.95-15.485-7.95s-15.263 7.625-15.485 7.95l-.25.363.25.362c.222.325 5.569 7.95 15.485 7.95s15.263-7.625 15.485-7.95l.25-.362-.25-.363z" />
        <path d="M19.299 23.476c-2.457 0-4.457-2.008-4.457-4.476s2-4.476 4.457-4.476c2.456 0 4.456 2.008 4.456 4.476s-2 4.476-4.456 4.476m0-10.23c-3.16 0-5.73 2.58-5.73 5.754 0 3.173 2.57 5.755 5.73 5.755 3.16 0 5.73-2.582 5.73-5.755s-2.57-5.755-5.73-5.755" />
      </g>
    </svg>
  ),
});
